<template>
    <C1Button
        type="button"
        variant="neutral"
        @click.stop.prevent="applyNow()"
        size="sm"
        class="af-btn-quick-apply afu-truncate"
    >
        <slot/>
    </C1Button>
</template>

<script>
    import ApplyJobMixin from "@/apps/jobview/001/components/Actions/ApplyJobMixin.vue";

    export default {
        name: 'QuickApplyJob',
        mixins: [ApplyJobMixin],
        props: {
            job: {
                type: Object,
                required: true
            }
        },
        computed: {
            $_job() {
                return this.job;
            },
        }

    };
</script>
